/* =============================================
   PRODUCT PAGE JS — Gallery, Variants, Sticky Bar
   ============================================= */

(function () {
  'use strict';

  /* ----- Mobile Sticky Bar ----- */
  function initStickyBar() {
    const bar = document.getElementById('product-sticky-bar');
    if (!bar) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (window.scrollY > 400) {
            bar.classList.add('visible');
          } else {
            bar.classList.remove('visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ----- Variant Selection ----- */
  function initVariants() {
    const pills = document.querySelectorAll('.variant-pill');
    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const group = pill.closest('.variant-group');
        group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        /* Update variant ID on ATC button — simplified, would need variant matrix in production */
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initStickyBar();
    initVariants();
  });
})();
